import { Row } from 'components/UIKit/Flex';

export type ToolbarType = {
  children: any,
  title: string
}

const styles = {
  container: {
    backgroundColor: '#fafafa',
    borderBottom: '1px solid #e5e5e5',
    padding: '1rem',
  },
  title: {
    alignItems: 'center',
    fontFamily: 'inherit',
    fontSize: '1.3rem',
    fontWeight: 'inherit',
    textTransform: 'capitalize',
  },
};

const Toolbar = ({
  children, title,
}: ToolbarType): React.Element => (
  <Row style={styles.container}>
    <Row>
      <h1 style={styles.title}>{title}</h1>
    </Row>

    <Row style={{ marginLeft: 'auto' }}>
      { children }
    </Row>
  </Row>
);

export default Toolbar;
